/*
    By Osvaldas Valutis, www.osvaldas.info
    Available for use under the MIT License
*/

'use strict';

(function($, window, undefined) {
    function bindInputFile(element) {
        var $label = element.next('label');
        var labelVal = $label.html();

        element.on('change', function(e) {
            var fileName = '';

            if (this.files && this.files.length > 1) {
                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
            } else if (e.target.value) {
                fileName = e.target.value.split('\\').pop();
            }

            if (fileName) {
                $label.find('span').html(fileName);
            } else{
                $label.html(labelVal);
            }
        });

        // Firefox bug fix
        element
            .on('focus', function() { element.addClass('has-focus'); })
            .on('blur', function() { element.removeClass('has-focus'); })
        ;
    }

    function bindElement(element) {
        bindInputFile($(element));
    }

    function bindInputFiles() {
        $('.inputfile').each(function() {
            bindInputFile($(this));
        });
    }

    window.bindElement = bindElement;
    window.bindInputFiles = bindInputFiles;
})(jQuery, window);